import { IRoute } from "shared/interface/types";
import { travelOrderRoutes } from "./travelOrderRoute";
import { travelShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";

export const TravelRoutes: IRoute[] = [...travelOrderRoutes, ...travelShelfPlanB2CRoutes];
